// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__G1clk","info":"PatientInfo_info__3h6mY"};